import status from './status';

const fetchWithCache = url => {
  let cache = window.__cache__;
  if (cache.has(url)) {
    return Promise.resolve(cache.get(url));
  }
  return fetch(url)
    .then(status)
    .then(res => res.json())
    .then(data => {
      cache.set(url, data);
      return data;
    });
};

export default fetchWithCache;
